import { render, staticRenderFns } from "./BrandModelPicker.vue?vue&type=template&id=706d5048"
import script from "./BrandModelPicker.vue?vue&type=script&lang=js"
export * from "./BrandModelPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports